import type { QuizResultsToggle } from '../quiz/QuizControls';
import type { SessionInit } from './sessions';
import { useResultSessionStore } from './store';

// Kết quả on a đề's own rail: opens or closes this tab's results session
export function useUnitResultsToggle(init: SessionInit | null): QuizResultsToggle {
  const tabId = init ? init.tabId : '';
  const open = useResultSessionStore((state) => Boolean(tabId && state.sessions[tabId]));
  const onToggle = () => {
    if (!init) return;
    const store = useResultSessionStore.getState();
    if (store.sessions[init.tabId]) store.close(init.tabId);
    else store.open(init);
  };
  return { open, onToggle };
}
